<template>
    <v-card :min-width="Modal.Processamento.larguraMinima" :max-width="Modal.Processamento.larguraMaxima">
        <v-card-title class="primary modal-title" primary-title>
            <span>Motivo Suspensão</span>
            <v-btn flat depressed @click="fecharModal">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text v-if="modoVisualizacao" class="pa-4">
            <p>{{ valor.motivo }}</p>
            <v-btn v-if="arquivo && arquivo.uri"
                   @click="downloadAnexo"
                   class="baixar-anexo-btn mt-3"
                   outlined
                   color="primary">
                Baixar Anexo
            </v-btn>
        </v-card-text>

        <v-card-text v-else class="az-form-content pa-0">
            <v-layout wrap align-center white class="pa-3">
                <v-flex xs12 sm12 d-flex>
                    <v-textarea
                        name="Motivo Suspensão"
                        v-model="valor.motivo"
                        rows="4"
                        placeholder="Informe o motivo de suspensão"
                        maxlength="255"
                        :rules="modoVisualizacao ? [] : [regras.obrigatorio]"
                        :required="!modoVisualizacao"
                        v-validate="modoVisualizacao ? '' : 'required'"
                        class="motivo-field"
                        :counter="modoVisualizacao ? false : 255"
                        :disabled="modoVisualizacao"
                        :readonly="modoVisualizacao">
                        <template v-slot:label>
                            Motivo<span v-if="!modoVisualizacao" class="asterisco-obrigatorio">*</span>
                        </template>
                    </v-textarea>
                </v-flex>

                <v-flex xs12 sm12 d-flex class="mt-3">
                    <div class="attachment-field">
                        <label class="attachment-label">
                            Anexo
                        </label>
                        <div v-if="!arquivo && !modoVisualizacao" class="mt-2">
                            <input
                                ref="fileInput"
                                type="file"
                                accept=".pdf"
                                @change="selecionarArquivo"
                                style="display: none"/>
                            <v-btn
                                @click="$refs.fileInput.click()"
                                class="anexar-arquivo-btn"
                                outlined
                                color="primary">
                                Anexar Arquivo
                            </v-btn>
                        </div>
                        <div v-else-if="arquivo" class="arquivo-selecionado mt-2">
                            <v-chip color="primary" outlined>
                                <v-icon left>mdi-file-pdf</v-icon>
                                {{ arquivo.nome }}
                                <v-icon v-if="arquivo.uri"
                                        right
                                        @click="downloadAnexo"
                                        class="ml-1"
                                        title="Baixar anexo">
                                    mdi-download
                                </v-icon>
                                <v-icon v-if="!modoVisualizacao" right @click="removerArquivo">mdi-close</v-icon>
                            </v-chip>
                        </div>
                        <div v-else-if="modoVisualizacao && !arquivo" class="mt-2">
                            <span class="text-muted">Nenhum anexo disponível</span>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-divider/>

        <v-card-actions v-if="!modoVisualizacao" class="px-3 py-2" >
            <v-btn color="botao-cancelar-color" flat outline @click="fecharModal">
                {{ 'Cancelar' }}
            </v-btn>
            <v-spacer/>
            <v-btn color="primary"
                   depressed
                   :disabled="!botaoSalvarHabilitado"
                   @click="salvarSuspensao">
                Salvar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'ModalSuspenderCompraDireta',
    props: {
        value: {
            required: true
        },
        modoVisualizacao: {
            type: Boolean,
            default: false
        },
        motivoSuspensao: {
            type: String,
            default: ''
        },
        anexoSuspensao: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            valor: {
                motivo: ''
            },
            arquivo: null,
            motivoOriginal: '',
            arquivoOriginal: null,
            Modal,
            regras: {
                obrigatorio: value => !!value || 'Campo obrigatório'
            }
        }
    },
    computed: {
        temAlteracoes() {
            if (this.modoVisualizacao) return false
            const motivoAlterado = this.valor.motivo !== this.motivoOriginal
            const arquivoAlterado = this.verificarAlteracaoArquivo()
            
            return motivoAlterado || arquivoAlterado
        },
        botaoSalvarHabilitado() {
            if (this.modoVisualizacao) return false
            return this.temAlteracoes
        }
    },
    watch: {
        modoVisualizacao: {
            immediate: true,
            handler(novoValor) {
                if (novoValor) {
                    this.carregarDadosExistentes()
                } else {
                    this.definirValoresOriginais()
                }
            }
        },
        motivoSuspensao: {
            immediate: true,
            handler(novoValor) {
                if (novoValor) {
                    this.valor.motivo = novoValor
                    if (!this.modoVisualizacao) {
                        this.motivoOriginal = novoValor
                    }
                } else {
                    this.valor.motivo = ''
                    if (!this.modoVisualizacao) {
                        this.motivoOriginal = ''
                    }
                }
            }
        },
        anexoSuspensao: {
            immediate: true,
            handler(novoValor) {
                this.$nextTick(() => {
                    if (novoValor) {
                        this.arquivo = {
                            nome: novoValor.nomeArquivo || novoValor.nome || 'Anexo de Suspensão.pdf',
                            file: null,
                            uri: novoValor.uri || null,
                            idVirtualizado: novoValor.idVirtualizado,
                            noProcessoDigital: novoValor.noProcessoDigital
                        }
                        if (!this.modoVisualizacao) {
                            this.arquivoOriginal = {
                                nome: novoValor.nomeArquivo || novoValor.nome || 'Anexo de Suspensão.pdf',
                                file: null,
                                uri: novoValor.uri || null,
                                idVirtualizado: novoValor.idVirtualizado,
                                noProcessoDigital: novoValor.noProcessoDigital
                            }
                        }
                    } else {
                        this.arquivo = null
                        if (!this.modoVisualizacao) {
                            this.arquivoOriginal = null
                        }
                    }
                })
            }
        }
    },
    methods: {
        carregarDadosExistentes() {
            if (this.motivoSuspensao) {
                this.valor.motivo = this.motivoSuspensao
                this.motivoOriginal = this.motivoSuspensao
            }
            if (this.anexoSuspensao) {
                this.arquivo = {
                    nome: this.anexoSuspensao.nomeArquivo || this.anexoSuspensao.nome || 'Anexo de Suspensão.pdf',
                    file: null,
                    uri: this.anexoSuspensao.uri || null,
                    idVirtualizado: this.anexoSuspensao.idVirtualizado,
                    noProcessoDigital: this.anexoSuspensao.noProcessoDigital
                }
                this.arquivoOriginal = {
                    nome: this.anexoSuspensao.nomeArquivo || this.anexoSuspensao.nome || 'Anexo de Suspensão.pdf',
                    file: null,
                    uri: this.anexoSuspensao.uri || null,
                    idVirtualizado: this.anexoSuspensao.idVirtualizado,
                    noProcessoDigital: this.anexoSuspensao.noProcessoDigital
                }
            } else {
                this.arquivo = null
                this.arquivoOriginal = null
            }
        },
        definirValoresOriginais() {
            this.motivoOriginal = this.motivoSuspensao || ''
            if (this.anexoSuspensao) {
                this.arquivoOriginal = {
                    nome: this.anexoSuspensao.nomeArquivo || this.anexoSuspensao.nome || 'Anexo de Suspensão.pdf',
                    file: null,
                    uri: this.anexoSuspensao.uri || null,
                    idVirtualizado: this.anexoSuspensao.idVirtualizado,
                    noProcessoDigital: this.anexoSuspensao.noProcessoDigital
                }
            } else {
                this.arquivoOriginal = null
            }
        },
        verificarAlteracaoArquivo() {
            if (!this.arquivoOriginal && this.arquivo) {
                return true
            }
            if (this.arquivoOriginal && !this.arquivo) {
                return true
            }
            if (this.arquivoOriginal && this.arquivo) {
                return this.arquivoOriginal.nome !== this.arquivo.nome
            }
            return false
        },
        async salvarSuspensao() {
            await this.validarCamposObrigatorios()
            const objParaSuspender = {
                motivo: this.valor.motivo,
                arquivo: this.arquivo
            }
            this.$emit('salvarSuspensao', objParaSuspender)
        },
        limparFormularioAposSalvar() {
            this.limparFormulario()
        },
        fecharModal() {
            this.$emit('fecharModalSuspensao')
            this.limparFormulario()
        },
        limparFormulario() {
            if (this.motivoSuspensao) {
                this.valor.motivo = this.motivoSuspensao
                this.motivoOriginal = this.motivoSuspensao
            }
            this.arquivo = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },
        async validarCamposObrigatorios() {
            const erros = []
            
            if (!this.valor.motivo || this.valor.motivo.trim() === '') {
                erros.push('Motivo é obrigatório')
            }
            
            if (erros.length > 0) {
                throw new Error(erros.join('. ') + '.')
            }
        },
        selecionarArquivo(event) {
            const file = event.target.files[0]
            if (file) {
                if (this.extensaoArquivoValida(file.name)) {
                    this.arquivo = {
                        nome: file.name,
                        file: file,
                        uri: null
                    }
                } else {
                    this.mostrarNotificacaoErro('Extensão do arquivo inválida. Por favor, selecione um arquivo .pdf')
                    event.target.value = ''
                }
            }
        },
        removerArquivo() {
            this.arquivo = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },
        downloadAnexo() {
            if (this.arquivo && this.arquivo.uri) {
                this.$emit('downloadAnexo', {
                    uri: this.arquivo.uri,
                    idVirtualizado: this.arquivo.idVirtualizado,
                    nomeDocumento: this.arquivo.nome,
                    noProcessoDigital: this.arquivo.noProcessoDigital
                })
            }
        },
        extensaoArquivoValida(nomeArquivo) {
            const extensao = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'), nomeArquivo.length)
            return extensao === '.pdf' || extensao === '.PDF'
        }
    }
}
</script>

<style scoped>
.modal-title {
    justify-content: space-between;
}

.modal-title .v-btn {
    padding: 0;
    margin: 0;
    color: #fff;
    box-sizing: border-box;
    min-width: 25px;
}

.anexar-arquivo-btn {
    background-color: white !important;
    border: 1px solid #1976d2 !important;
    color: #1976d2 !important;
    text-transform: none;
    font-weight: normal;
}

.anexar-arquivo-btn:hover {
    background-color: rgba(25, 118, 210, 0.04) !important;
}

.arquivo-selecionado {
    display: flex;
    align-items: center;
}

.asterisco-obrigatorio {
    color: red;
}

.arquivo-selecionado .v-chip {
    background-color: #f5f5f5 !important;
}

.attachment-field {
    width: 100%;
}

.attachment-label {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
}

.baixar-anexo-btn {
    background-color: transparent !important;
    border: 1px solid #1976d2 !important;
    color: #1976d2 !important;
    text-transform: none;
    font-weight: normal;
}

.baixar-anexo-btn:hover {
  background-color: #fffffe !important;
}
</style>